import {
  DEAL_STAGE,
  DROPPED_MOTIVATION_OPTIONS,
} from '@tassomutuo-backoffice/types';

export const getMotivations = (stage:string|undefined|null) => {
    switch (stage) {
      case DEAL_STAGE.CONTATTARE_CLIENTE:
        return DROPPED_MOTIVATION_OPTIONS.CONTATTARE_CLIENTE;
      case DEAL_STAGE.APPUNTAMENTO_DA_RIFISSARE:
        return DROPPED_MOTIVATION_OPTIONS.CONTATTARE_CLIENTE;
      case DEAL_STAGE.APPUNTAMENTO_DA_CONFERMARE:
        return DROPPED_MOTIVATION_OPTIONS.APPUNTAMENTO_DA_CONFERMARE;
      case DEAL_STAGE.APPUNTAMENTO_CONFERMATO:
        return DROPPED_MOTIVATION_OPTIONS.APPUNTAMENTO_CONFERMATO;
      default:
        return DROPPED_MOTIVATION_OPTIONS.ALTRO;
    }
  }